import React from "react";

import PageLayout from "../../layouts/PageLayout";
import { useTranslation } from "react-i18next";

const HelpContainer: React.FC = () => {
  const { t } = useTranslation("help");
  return (
    <PageLayout>
      <div className="mt-14">
        <div className="max-w-7xl mx-auto my-16">
          <div className="max-w-3xl mx-auto divide-y-2 divide-gray-200">
            <h2 className="text-center text-3xl font-extrabold text-gray-900 sm:text-4xl">
              {t("title")}
            </h2>

            <div className="mt-6 text-center">
              <span>
                {t("support")}
                <a
                  href="https://support.flashrouters.com/privacyhero-router-setup-guide/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-orange-500"
                >
                  {t("supportLink")}
                </a>
              </span>
            </div>

            <div className="mt-6 text-center">
              <span>
                {t("setup")}
                <a
                  href="https://www.flashrouters.com/contact/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-orange-500"
                >
                  {t("setupLink")}
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};
export default HelpContainer;
